/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import { defineMessages } from 'react-intl';

export const GenesysBotConnector = defineMessages({
  connectAssistantTab: {
    id: 'GenesysBotConnector.connectAssistantTab',
    defaultMessage: 'Connect assistant'
  },
  applicationTab: {
    id: 'GenesysBotConnector.applicationTab',
    defaultMessage: 'Genesys bot connector'
  },
  configureGenesysBotConnectorTab: {
    id: 'GenesysBotConnector.configureGenesysBotConnectorTab',
    defaultMessage: 'Configure Genesys bot connector'
  }
});

export const sharedGenesysBotConnectorMessages = defineMessages({
  saveChanges: {
    id: 'GenesysBotConnector.sharedGenesysBotConnectorMessages.saveChanges',
    defaultMessage: 'Save Changes'
  }
});
